export function releaseItem(obj) {
  let post_type = obj.type; //投稿のタイプ
  let post_date = obj.public_date; //投稿の日付
  let post_category = obj.category; //投稿のカテゴリー
  let post_title = obj.title; //投稿タイトル
  let post_url_target = obj.link_url_target; //投稿の外部リンク判定
  let post_url_content = obj.content; //投稿テキスト
  let post_format = obj.format; //投稿フォーマット

  //li要素を作成
  const item = document.createElement('li');
  item.classList.add('c-border_bottom', 'u-color_border--grayPale');

  //a要素を作成
  const anchor_item = document.createElement('a');
  anchor_item.classList.add('c-newsType01');

  //a要素のリンク先を設定
  if( post_type === 'SPACE' ) { //「post_type」が「SPACE」の場合
    anchor_item.classList.add('is-disabled');

  } else if( post_type === 'PDF' ) { //「post_type」が「PDF」の場合
    let url = obj.pdf_url;
    anchor_item.setAttribute('href', url);
    anchor_item.setAttribute('target', '_blank');

  } else if( post_type === 'DETAIL' ) { //「post_type」が「DETAIL」の場合
    let url = obj.detail_url;
    anchor_item.setAttribute('href', url);

  } else if ( post_type === 'URL' ) { //「post_type」が「URL」の場合
    let url = obj.link_url;
    anchor_item.setAttribute('href', url);
    anchor_item.setAttribute('target', post_url_target);
  }

  //infoブロックを作成
  const info_block = document.createElement('div');
  info_block.classList.add('c-newsType01_info', 'u-flex', 'u-flex_items--center');
  info_block.innerHTML = `<p class="c-txt_date">${post_date}</p>
  <span class="c-tagType01">${post_category}</span>
  `;
  anchor_item.appendChild(info_block);

  //タイトルブロックを作成
  const title_block = document.createElement('p');
  title_block.classList.add('c-newsType01_txt', 'u-mt--16');
  title_block.textContent = post_title;
  if(post_type === 'PDF') { //「post_type」が「PDF」の場合
    let icon = document.createElement('span');
    icon.classList.add('c-newsType01_ico--pdf');
    title_block.appendChild(icon);

  } else { //「post_type」が「PDF」以外の場合
    if(post_url_target) { //「link_url_target」に値が存在する場合
      let icon = document.createElement('span');
      icon.classList.add('c-newsType01_ico--anchor');
      title_block.appendChild(icon);
    }
  }
  anchor_item.appendChild(title_block);

  //テキストブロック
  if( post_format === 'EIR' && post_url_content ) { //「post_format」が「EIR」の場合
    let txt = document.createElement('p');
    txt.classList.add('c-newsType01_detail');
    txt.innerHTML = post_url_content;
    anchor_item.appendChild(txt);
  }

  item.appendChild(anchor_item);
  return item;
}